<script setup>
import { ref, computed, onMounted, getCurrentInstance, watch } from 'vue'
import {useRoute, useRouter} from 'vue-router'
import _ from 'lodash'
import { usePageLoadingStore } from "../../../../stores/pageLoading";
import { useUserStore } from "../../../user/stores/user";
import SNBAdmin from "../../../../layouts/nav/SNBAdmin.vue";
import KSAInputNumber from "../../../../components/ui-components/input/KSAInputNumber.vue";
import KSASecondaryButton from "../../../../components/ui-components/button/KSASecondaryButton.vue";
import jobFairCorpService from "@/pages/user/services/jobFair/jobFairCorpService";
import { useAlertStore } from '../../../../stores/alertStore';
const { $alert, $confirm } = useAlertStore();
const route = useRoute();
const router = useRouter()
const globals = getCurrentInstance().appContext.config.globalProperties;
const { $toast, $gb } = globals;
const loadingStore = usePageLoadingStore()
const userStore = useUserStore()
const isStudent = ref(true);
const schoolGbRef = ref(null); // 학력
const workAreaRef = ref(null); // 근무지역
const salaryGbRef = ref(null); // 급여
const editorRef = ref(null); // 기타 요건

const jobNoticeSeq = ref(route.query.jobNoticeSeq || '');
const resumeId = ref(route.query.resumeId || '');
const inteYn = ref(route.query.inteYn || '');
const mode = ref(route.query.mode || '');
const corpId = ref(route.query.corpId || '');
const ojfGb = ref(route.query.ojfGb || '');

const tabList = ref([
  { title: '기본 정보', active: true, completed: false, closed: false },
  { title: '소개', active: false, completed: false, closed: false },
  { title: '학력', active: false, completed: false, closed: false },
  { title: '포트폴리오', active: false, completed: false, closed: false },
  { title: '자격증 및 외국어', active: false, completed: false, closed: false },
  { title: '업무 경험', active: false, completed: false, closed: false },
  { title: '병역', active: false, completed: false, closed: false },
])

const saveIsDisabled = ref(false)

onMounted(()=> {
  ojfCropJobNoticeDetail();

  if(userStore.user.userGb !== '01' && userStore.user.userGb !== 'STUDENT') {
    isStudent.value = false;
  }

  _.each(data_interests.value, el => {el.on = false;})
  _.each(data_job.value, el => {el.on = false;})


  // 저장 비활성화
  //saveIsDisabled.value = Number(moment().format('YYYYMMDD')) >= 20230527;
})

const currentTabIndex = computed(()=>{
  return _.findIndex(tabList.value, {'active': true});
})

const jobNoticeDetail = ref({
  "jobNoticeSeq": 0,
  "jobName": '', // 채용공고명
  "interests": '', // 관심카테고리
  "job": '', // 직무
  "recruitArea": '', // 모집분야명
  "recruitCnt": 0, // 모집인원
  "jobExperience": '', //  경력
  "schoolGb": '', // 학력 05 고졸 01 대학(2,3년) 02 대학(4년) 03 대학원(석사) 04 대학원(박사)
  "specialTreat": '', // 우대사항(자격증)
  "workArea1": '', // 근무지역_시도
  "workArea2": '', // 근무지역_시군구
  "workHomeYn": '', // 재택가능여부
  "workType": '', // 근무형태
  "salaryGb": '01', // 급여구분
  "salary": 0, // 급여
  "note": '', // 기타 요건
})

const inputError = ref({
  jobName: '', // 채용공고명
  interests: '', // 관심카테고리
  job: '', // 직무
  recruitArea: '',// 모집분야명
  recruitCnt: '', // 모집인원
  jobExperience: '', //  경력
  schoolGb: '', // 학력
  specialTreat: '', // 우대사항(자격증)
  workArea: '', // 근무지역
  workHomeYn: '', // 재택가능여부
  workType: '', // 근무형태
  salary: '', // 급여구분
})

const data_interests = ref(globals.$interests) // 관심 카테고리
const data_job = ref(globals.$desiredJob) // 직무
const data_jobExperience = ref(globals.$jobExperience) // 경력
const data_workType = ref(globals.$workType) // 근무형태

// 관심 카테고리
const interestCount = computed(()=>{
  return _.filter(data_interests.value, {'on': true}).length || 0;
})

const onClickInterest = (interest) => {
  inputError.value.interests = '';
  if(interest.on) {
    interest.on  = false;
  } else {
    if(interestCount.value < 3) {
      interest.on = true;
    } else {
      inputError.value.interests = '최대 3개까지 선택할 수 있습니다.';
    }
  }
}

// 직무
const onClickJob = (job) => {
  inputError.value.job = '';
  if(job.on) {
    job.on  = false;
  } else {
    job.on = true;
  }
}

// 경력
const onClickJobExperience = (jobExperience) => {
  inputError.value.jobExperience = '';
  if(jobExperience.on) {
    jobExperience.on  = false;
  } else {
    jobExperience.on = true;
  }
}

// 근무지역
const onSelectedWorkArea1 = (option) => {
  jobNoticeDetail.value.workArea1 = option;
  inputError.value.workArea = '';
}

const onSelectedWorkArea2 = (option) => {
  jobNoticeDetail.value.workArea2 = option;
  inputError.value.workArea = '';
}

const onClickWorkHomeYn = (select) => {
  inputError.value.workHomeYn = '';
  if(select === 'Y') {
    jobNoticeDetail.value.workHomeYn = 'N';
  } else {
    jobNoticeDetail.value.workHomeYn = 'Y';
  }
}

// 근무형태
const onClickWorkType = (selectedWorkType) => {
  inputError.value.workType = '';
  data_workType.value.forEach(item => {
    item.on = (item === selectedWorkType);
  });
}

const initSelectGbRefs = () => {
  setTimeout(()=>{
    if (currentTabIndex.value === 2) { // 학력
      for(let i=0; i<schoolGbRefs.value.length; i++) {
        schoolGbRefs.value[i].initSelectedOption();
      }
      for(let i=0; i<majorGbRefs.value.length; i++) {
        majorGbRefs.value[i].initSelectedOption();
      }
      for(let i=0; i<submajorTypeGbRefs.value.length; i++) {
        submajorTypeGbRefs.value[i].initSelectedOption();
      }
      for(let i=0; i<submajorGbRefs.value.length; i++) {
        submajorGbRefs.value[i].initSelectedOption();
      }
      for(let i=0; i<eduTenureGbRefs.value.length; i++) {
        eduTenureGbRefs.value[i].initSelectedOption();
      }
      for(let i=0; i<fullScoreGbRefs.value.length; i++) {
        fullScoreGbRefs.value[i].initSelectedOption();
      }
    } else if (currentTabIndex.value === 4) { // 자격증및외국어
      for(let i=0; i<langGbRefs.value.length; i++) {
        langGbRefs.value[i].initSelectedOption();
      }
      for(let i=0; i<langLevelGbRefs.value.length; i++) {
        langLevelGbRefs.value[i].initSelectedOption();
      }
    }
  }, 100)
}

// 공고 정보
const ojfCropJobNoticeDetail = () => {
  loadingStore.loading = false;

  let paramObj = {
    jobNoticeSeq: jobNoticeSeq.value,
  }
  jobFairCorpService.ojfCropJobNoticeDetail(paramObj)
      .then( (res) => {
        loadingStore.loading = false;
        if(res.data.code.toLowerCase() === 'success') {
          const result = res.data.result;
          // console.log(result);
          jobNoticeDetail.value = result;

          // 모집 분야
          // 관심 카테고리
          if(result.interests !== null && result.interests !== '') {
            _.each(data_interests.value, el => {
              el.on = result.interests.indexOf(el.label) > -1;
            })
          }
          // 직무
          if(result.job !== null && result.job !== '') {
            _.each(data_job.value, el => {
              el.on = result.job.indexOf(el.label) > -1;
            })
          }
          // 지원 자격 / 근무조건
          // 경력
          if(result.jobExperience !== null && result.jobExperience !== '') {
            _.each(data_jobExperience.value, el => {
              el.on = result.jobExperience.indexOf(el.label) > -1;
            })
          }
          // 학력
          if(result.schoolGb) {
            schoolGbRef.value.initSelectedOption(result.schoolGb);
          }
          // 근무지역
          if(result.workArea1 && result.workArea2) {
            workAreaRef.value.initSelectedOption(result.workArea1, result.workArea2)
          }
          // 근무형태
          if(result.workType !== null && result.workType !== '') {
            _.each(data_workType.value, el => {
              el.on = result.workType.indexOf(el.label) > -1;
            })
          }
          // 급여
          if(result.salaryGb) {
            salaryGbRef.value.initSelectedOption(result.salaryGb);
          }
          // 기타 요건
          if (result.note) {
            setTimeout(() => {
              editorRef.value.init(result.note);
            }, 100)
          }
        }
      }).catch( (error) =>  {
    loadingStore.loading = false;
    console.log(error);
  });
}

// 공고 수정
const updateJobNotice = (jobNoticeSeq, ojfId, resumeId, inteYn) => {
  let isInvalid = false;

  // 공고 제목 저장
  const { jobName } = jobNoticeDetail.value;
  inputError.value.jobName = '';

  if(!jobName) {
    inputError.value.jobName = '공고 제목을 입력하세요.';
    isInvalid = true;
  } else if (jobName.length > 50) {
    inputError.value.jobName = '공고 제목을 50자 이내로 입력하세요.';
    isInvalid = true;
  }

  // 모집 분야
  const interests = _.map(_.filter(data_interests.value, {'on': true}), 'value').join(','); // 관심 카테고리
  const job = _.map(_.filter(data_job.value, {'on': true}), 'value').join(','); // 직무
  const { recruitArea, recruitCnt } = jobNoticeDetail.value; // 모집분야명, 모집인원

  inputError.value.interests = '';
  inputError.value.job = '';
  inputError.value.recruitArea = '';
  inputError.value.recruitCnt = '';

  if(!interests) {
    inputError.value.interests = '관심 카테고리를 선택하세요.';
    isInvalid = true;
  }

  if(!job) {
    inputError.value.job = '직무를 선택하세요.';
    isInvalid = true;
  }

  if (!recruitArea) {
    inputError.value.recruitArea = '모집분야명을 입력하세요.';
    isInvalid = true;
  }

  if (!recruitCnt) {
    inputError.value.recruitCnt = '모집인원을 입력하세요.';
    isInvalid = true;
  }

  // 지원 자격 / 근무조건
  const jobExperience = _.map(_.filter(data_jobExperience.value, {'on': true}), 'value').join(','); // 경력
  const workType = _.map(_.filter(data_workType.value, {'on': true}), 'value').join(','); // 근무형태
  const {schoolGb, specialTreat, workArea1, workArea2, workHomeYn, salaryGb, note } = jobNoticeDetail.value; // 학력, 우대 사항(자격증) 근무지역1, 근무지역2

  inputError.value.workArea1 = '';
  inputError.value.workArea2 = '';
  inputError.value.workHomeYn = '';

  if (!jobExperience) {
    inputError.value.jobExperience = '경력을 선택하세요.';
    isInvalid = true;
  }

  if (!schoolGb) {
    inputError.value.schoolGb = '학력을 선택하세요.';
    isInvalid = true;
  }

  if (!specialTreat) {
    inputError.value.specialTreat = '우대 사항을 입력하세요.';
    isInvalid = true;
  }

  const area1filter = !workArea1 || workArea1 === '시/도 선택';
  const area2filter = !workArea2 || workArea2 === '시/구/군 선택';
  const area3filter = !workHomeYn;

  if(area3filter ? (area1filter || area2filter) : false) {
    inputError.value.workArea = '근무지역을 선택하세요.';
    isInvalid = true;
  } else {
    inputError.value.workArea = '';
  }

  if (!workType) {
    inputError.value.workType = '근무형태를 선택하세요.';
    isInvalid = true;
  }

  let salary = jobNoticeDetail.value.salary;

  if (salaryGb === '01') {
    if (salary) {
      salary = 0;
    }
  } else if (salaryGb !== '01') {
    if (salary === 0 || salary === '' || salaryGb === '') {
      inputError.value.salary = '급여를 선택하세요.';
      isInvalid = true;
    }
  }

  // 수정 처리
  if(!isInvalid) {

    loadingStore.loading = true;

    jobFairCorpService.ojfCropJobNoticeUpdate(
        jobNoticeSeq, jobName,
        interests, job, recruitArea, recruitCnt,
        jobExperience, schoolGb, specialTreat,
        workArea1, workArea2, workHomeYn, workType,
        salaryGb, salary, note,
    ).then(async (res) => {
      loadingStore.loading = false;

      if (res.data.code.toLowerCase() === 'success') {
        const result = res.data.result;

        // 면접제안 등록
        const ojfCropInterviewProposalCreate = async () => {
          const ok = await $confirm(["채용공고 수정이 완료되었습니다.", "해당 채용공고로 면접제안을 하시겠습니까?"], "면접제안");
          if(!ok) {
            return -1;
          } else {
            let paramObj = {
              ojfId: ojfId,
              resumeId: resumeId,
              jobNoticeSeq: jobNoticeSeq,
            }

            loadingStore.loading = true;
            jobFairCorpService.ojfCropInterviewProposalCreate(paramObj)
                .then( (res) => {
                  loadingStore.loading = false;
                  if(res.data.code.toLowerCase() === 'success') {
                    const result = res.data.result;
                    $alert(["면접제안을 하였습니다."]);
                  } else {
                    $alert(["면접제안을 실패하였습니다."]);
                  }
                }).catch( (error) =>  {
                  loadingStore.loading = false;
                  $alert(["제안을 실패하였습니다."]);
                });
          }

        }

        if (inteYn === 'N') {
          // inteYn가 'N'이면 면접제안 가능
          // 'Y'면 이미 면접제안이 완료되어 공고 수정만 가능
          ojfCropInterviewProposalCreate();
          router.push({name: 'MatchingJobFairDetail', params:{id: ojfId}})
        } else {
          if (mode.value === 'approved') { // 온라인 특별채용관-참가현황 에서 사용
            $toast("", "수정되었습니다");
            router.push({name: 'ApprovedJoinStateDetail', params:{id: ojfId}})
          } else if (mode.value === 'corporation') { // 기업관리>특별채용관-참가현황 에서 사용
              $toast("", "수정되었습니다");
              router.push({ name: 'CorporationJobFairDetail', query : { ojfId: ojfId, corpId: corpId.value }});
          } else {
            $alert(["채용공고 수정이 완료되었습니다.."]);
            router.push({name: 'MyPageCorpJobFairDetail', params:{id: ojfId}})
          }
        }
      }
    }).catch((error) => {
      loadingStore.loading = false;
      console.log(error);
    });

  } else {
    $toast("error", "올바르게 입력되지 않은 항목이 있습니다.");
  }

}

const clickCancel = async (ojfId) => {
  $alert(["채용공고 수정이 취소되었습니다."]);
  if (mode.value === 'approved') {
    router.push({name: 'ApprovedJoinStateDetail', params:{id: ojfId}})
  } else if (mode.value === 'corporation') {
    router.push({ name: 'CorporationJobFairDetail', query : { ojfId: ojfId, corpId: corpId.value }});
  }
}

// 특수문자 작성 안됨
const filterText = (value) => {
  return value.replace(/[^a-zA-Z0-9ㄱ-ㅎ가-힣\s]/g, ''); // 특수문자 제거
}

const onInputChange = (event, key) => {
  jobNoticeDetail.value[key] = filterText(event.target.value); // 필터링된 값 적용
  if (key === 'jobName') {
    inputError.value.jobName = '' ? '공고 제목을 입력하세요.' : '';
  } else if (key === 'recruitArea') {
    inputError.value.recruitArea = '' ? '모집분야명을 입력하세요.' : '';
  } else if (key === 'specialTreat') {
    inputError.value.specialTreat = '' ? '우대 사항을 입력하세요.' : '';
  }
}

const validateText = (key) => {
  if (key === 'recruitCnt') {
    inputError.value.recruitCnt = '' ? '모집인원을 입력하세요.' : '';
  } else {
    inputError.value.salary = '' ? '급여를 선택하세요.' : '';
  }
}

watch(
    () => jobNoticeDetail.value.schoolGb,
    (newVal) => {
      inputError.value.schoolGb = newVal === '' ? '학력을 선택하세요.' : ''
    }
)

</script>

<template>
  <div class="content">
    <div class="record-wrap">
      <div class="sub-title">
        <h3>채용공고 수정</h3>
      </div>
      <p class="mt-xs">{{ ojfGb === '01' ? '기업공채관' : '채용박람회' }}에 등록할 채용공고를 작성하세요. (모든 이력사항은 필수 입력사항입니다.)</p>
      <!-- s: 공고 제목 -->
      <div class="content-inner resume-title">
        <KSAInput v-model="jobNoticeDetail.jobName" @input="(event) => onInputChange(event, 'jobName')" maxLength="50" placeholder="공고 제목을 50자 이내로 입력하세요." />
        <p>
          <small style="color:#E71414;">{{ inputError.jobName }}</small>
        </p>
      </div>
      <!-- e: 공고 제목 -->
      <!-- s: 모집 분야 -->
      <div class="table-form">
        <table class="vertical">
          <colgroup>
            <col width="20%" />
            <col />
          </colgroup>
          <tr>
            <th colspan="2">모집 분야</th>
          </tr>
          <tr>
            <th><span class="mark">관심 카테고리(최대3개)</span></th>
            <td>
              <ul class="grid category-wrap">
                <li :class="{'active': interest.on}" v-for="interest in data_interests" @click="onClickInterest(interest)">
                  {{ interest.label }}
                </li>
              </ul>
              <p>
                <small style="color:#E71414;">{{ inputError.interests }}</small>
              </p>
            </td>
          </tr>
          <tr>
            <th><span class="mark">직무</span></th>
            <td>
              <ul class="grid category-wrap">
                <li :class="{'active': job.on}" v-for="job in data_job" @click="onClickJob(job)">
                  {{ job.label }}
                </li>
              </ul>
              <p>
                <small style="color:#E71414;">{{ inputError.job }}</small>
              </p>
            </td>
          </tr>
          <tr>
            <th><span class="mark">모집분야명</span></th>
            <td>
              <KSAInput v-model="jobNoticeDetail.recruitArea" @input="(event) => onInputChange(event, 'recruitArea')" placeholder="모집분야명을 입력하세요. (ex. 경영지원, 마케팅담당, 운영업무, 등)" />
              <p>
                <small style="color:#E71414;">{{ inputError.recruitArea }}</small>
              </p>
            </td>
          </tr>
          <tr>
            <th><span class="mark">모집인원</span></th>
            <td>
              <div class="grid half">
                <KSAInputNumber v-model="jobNoticeDetail.recruitCnt" @input="validateText('recruitCnt')" placeholder="0" maxLength="3" /> 명
              </div>
              <p>
                <small style="color:#E71414;">{{ inputError.recruitCnt }}</small>
              </p>
            </td>
          </tr>
        </table>
      </div>
      <!-- e: 모집 분야 -->
      <!-- s: 지원 자격 / 근무조건 -->
      <div class="table-form mt-xs">
        <table class="vertical">
          <colgroup>
            <col width="20%" />
            <col />
          </colgroup>
          <tr>
            <th colspan="2">지원 자격 / 근무조건</th>
          </tr>
          <tr>
            <th><span class="mark">경력</span></th>
            <td>
              <ul class="grid category-wrap">
                <li :class="{'active': jobExperience.on}" v-for="jobExperience in data_jobExperience" @click="onClickJobExperience(jobExperience)">
                  {{ jobExperience.label }}
                </li>
              </ul>
              <p>
                <small style="color:#E71414;">{{ inputError.jobExperience }}</small>
              </p>
            </td>
          </tr>
          <tr>
            <th><span class="mark">학력</span></th>
            <td>
              <div class="grid half">
                <KSASelect ref="schoolGbRef" class="select" v-model="jobNoticeDetail.schoolGb" :options="$gb.SCHOOL_GB"/>
              </div>
              <p>
                <small style="color:#E71414;">{{ inputError.schoolGb }}</small>
              </p>
            </td>
          </tr>
          <tr>
            <th><span class="mark">우대 사항(자격증)</span></th>
            <td>
              <KSAInput v-model="jobNoticeDetail.specialTreat" @input="(event) => onInputChange(event, 'specialTreat')" maxLength="50" placeholder="우대 사항을 50자 이내로 입력하세요." />
              <p>
                <small style="color:#E71414;">{{ inputError.specialTreat }}</small>
              </p>
            </td>
          </tr>
          <tr>
            <th><span class="mark">근무지역</span></th>
            <td>
              <KSASelectResidenceArea
                  class="select"
                  ref="workAreaRef"
                  @selectOption1="onSelectedWorkArea1"
                  @selectOption2="onSelectedWorkArea2"
              />
              <ul class="grid category-wrap">
                <li :class="{'active': jobNoticeDetail.workHomeYn === 'Y'}" @click="onClickWorkHomeYn(jobNoticeDetail.workHomeYn)">
                  재택근무 가능
                </li>
              </ul>
              <p>
                <small style="color:#E71414;">{{ inputError.workArea }}</small>
              </p>
            </td>
          </tr>
          <tr>
            <th><span class="mark">근무형태</span></th>
            <td>
              <ul class="grid category-wrap">
                <li :class="{'active': workType.on}" v-for="workType in data_workType" @click="onClickWorkType(workType)">
                  {{ workType.label }}
                </li>
              </ul>
              <p>
                <small style="color:#E71414;">{{ inputError.workType }}</small>
              </p>
            </td>
          </tr>
          <tr>
            <th><span class="mark">급여</span></th>
            <td>
              <div class="grid half">
                <div class="mr-xs select-min">
                  <KSASelect ref="salaryGbRef" class="select" v-model="jobNoticeDetail.salaryGb" :options="$gb.SALARY_GB"/>
                </div>
                <KSAInputNumber v-model="jobNoticeDetail.salary" :disabled="jobNoticeDetail.salaryGb === '01'" @input="validateText('salary')" maxLength="6" placeholder="0"/>
                <span class="ml-xs">만원</span>
              </div>
              <p>
                <small style="color:#E71414;">{{ inputError.salary }}</small>
              </p>
            </td>
          </tr>
          <tr>
            <th>기타 요건</th>
            <td>
              <KSACKEditor ref="editorRef" v-model="jobNoticeDetail.note" />
            </td>
          </tr>
        </table>
      </div>
      <!-- e: 지원 자격 / 근무조건 -->
      <div class="btn-wrap space-between">
        <KSASecondaryButton class="gray_button" text="취소" @click="clickCancel(jobNoticeDetail.ojfId)" />
        <KSAPrimaryButton text="수정 완료" @click="updateJobNotice(jobNoticeSeq, jobNoticeDetail.ojfId, resumeId, inteYn)" :disabled="saveIsDisabled"/>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>

@import "../../../../assets/scss/theme";

hr {
  border: 0;
  height: 1px;
  background-color: $gray-regular_color;
  margin: 40px 0;
}

.select-min {
  .select-wrap {
    width: 30%;
  }
}

.container {
  padding-bottom: 0;
  .content {
    width: 100%;
    display: flex;
    flex-direction: row-reverse;
    .record-wrap {
      width: 100%;
      margin-right: 0;
      padding-bottom: 0;
      .resume-title {
        padding: 20px 0;
      }
      .table-form {
        table {
          th {
            text-align: left;
          }
        }
      }
    }
  }
  .btn-wrap {
    .inner {
      width: calc(100% - 352px);
      margin: auto;
      padding: 0;
    }
    .flex-wrap {
      justify-content: space-between;
    }
  }
}

</style>